<script setup>
import { ref } from 'vue'
import { InformationCircleIcon } from '@heroicons/vue/24/solid'
import ToolTip from '@/components/elements/ToolTip.vue'

defineProps({
  label: {
    type: String,
    default: '',
  },
  description: {
    type: String,
    default: '',
  },
  position: {
    type: String,
    default: 'right',
  },
})

const hover = ref(false)
</script>

<template>
  <div class="flex items-center space-x-1">
    <label class="text-sm font-medium leading-6 text-gray-500">{{ label }}</label>
    <InformationCircleIcon class="h-4 w-4" @mouseover="hover = true" @mouseleave="hover = false" />
    <ToolTip v-if="hover == true" :text="description" :position="position" />
  </div>
</template>
